import React from 'react'
import Button from '../../Common/Button'
import image from './../../../data/other/7thimg.jpg'

const Parlexeffect = () => {
    
  return (
    <div className="w-full min-h-[1100px] bg-cover relative bg-fixed" style={{backgroundImage:`url(${image})`}}>
        <div className='w-[60%] h-[80%] absolute bottom-0 left-10 bg-yellow-600 opacity-50 rounded-t-3xl p-6'>
            <h1 className='text-white lg:text-6xl font-bold mt-10'>Transform Your Operations Today! Explore Our Industries Automations, Solutions</h1>
            <p className='text-slate-300 font-bold text-xl mt-8'>Drive action by emphasizing the transformative impact of  Industries Automations, Solutions, on business operations.</p>
            <div className='flex flex-row gap-6 mt-10'>
                <Button text={true} firstTag={"Contact Us"}/>
                <Button text={false} secondTag={"Learn More ->"}/>
            </div>
        </div>
    </div>
  )
}

export default Parlexeffect